/**
* Click to Play JS
* -----------------------------------------------------------------------------
*
* All the JS for the Click to Play component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'click-to-play',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.click-to-play' ).each( function( key, component ) {
        const imageWrapper = $( '.click-to-play__image-wrapper' )[0];
        const image = $( imageWrapper ).find( '.click-to-play__image' );
        const imageInner = $( imageWrapper ).find( '.click-to-play__image-inner' );
        const loopVideo = $( imageWrapper ).find( '.video-image-container' );
        const prevImage = $( '.click-to-play__prev-image-wrapper' )[0];
        const nextImage = $( '.click-to-play__next-image-wrapper' )[0];

        $( nextImage ).removeClass( 'hidden' );

        const pinner = gsap.timeline( {
          scrollTrigger: {
            trigger: $( component ).find( '.click-to-play__featured' ),
            pin: true,
            start: 'top 33%',
            end: '+=' + ( window.innerHeight * 0.67 ),
            pinSpacing: false,
            scrub: 2,
          },
        } );

        const graphicsPinner = gsap.timeline( {
          scrollTrigger: {
            trigger: $( component ).find( '.click-to-play__graphics' ),
            pin: true,
            start: 'top top',
            end: '+=' + ( $( component ).find( '.click-to-play__inner-inner' ).outerHeight() - ( window.innerHeight * 0.67 ) ),
            scrub: 2,
          },
        } );

        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: imageWrapper,
            start: 'top 33%',
            end: '+=500vh',
            scrub: 0,
          },
        } );

        const imageWidth = 600;
        const imageHeight = 338;
        const clipLeft = ( document.documentElement.clientWidth - imageWidth ) / 2;
        const clipRight = ( document.documentElement.clientWidth - imageWidth + 24 ) / 2;
        const clipBottom = window.innerHeight - imageHeight;
        const scaleAmount = ( imageWidth + 32 ) / window.innerWidth;

        tl.fromTo( image, {clipPath: 'inset(0px ' + clipRight + 'px ' + clipBottom + 'px ' + clipLeft + 'px)'}, {clipPath: 'inset(0px 0px 0px 0px)', ease: 'linear'}, 0 );
        tl.to( image, {y: '-33%', ease: 'linear'}, 0 );
        tl.fromTo( imageInner, {scale: scaleAmount}, {scale: 1, ease: 'linear'}, 0 );
        tl.to( prevImage, {y: '0%', ease: 'linear'}, 0 );
        tl.to( nextImage, {y: '100%', ease: 'linear'}, 0 );

        if ( loopVideo.length ) {
          tl.fromTo( loopVideo, {opacity: 0}, {opacity: 1, ease: 'linear'}, 0 );
        }
      } );

      // Link Cursor
      const zone = $( '.click-to-play .cursor-zone' )[0];
      const cursor = $( '.click-to-play .custom-cursor' )[0];
      const innerCursor = $( '.click-to-play .custom-cursor__inner' )[0];

      let x = 0;
      let y = 0;
      let active = false;
      let escaped = false;

      if ( $( zone ).length ) {
        console.log( zone );
        zone.addEventListener( 'mouseenter', () => {
          active = true;
          cursor.style.opacity = 1;
          innerCursor.style.transform = `scale(1)`;
        } );

        zone.addEventListener( 'mouseleave', () => {
          active = false;
          escaped = false;
          zone.style.cursor = 'auto';
          innerCursor.style.transform = `scale(0)`;

          setTimeout( function() {
            cursor.style.opacity = 0;
          }, 200 );
        } );

        // Track mouse ONLY relative to the zone
        zone.addEventListener( 'mousemove', ( e ) => {
          const rect = zone.getBoundingClientRect();

          x = e.clientX - rect.left - ( rect.width / 2 ) + 60;
          y = e.clientY - rect.top - ( rect.height * 0.8 );

          // Escape hatch check
          const escapeTarget = e.target.closest( '.native-cursor, .loop-video-btn' );

          if ( escapeTarget ) {
            escaped = true;
            cursor.style.opacity = 0;
            zone.style.cursor = 'auto';
          } else {
            escaped = false;
            cursor.style.opacity = 1;
            zone.style.cursor = 'none';
          }

          if ( active && !escaped ) {
            const maxRotation = 25;
            const vw = window.innerWidth;
            const rotateAmount = -maxRotation + ( e.clientX / vw ) * ( maxRotation * 2 );

            cursor.style.transform =
            `translate(${x}px, ${y}px) translate(-50%, -50%) rotate( ${rotateAmount}deg )`;
          }
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'click-to-play', COMPONENT );
} )( app );
